module.exports = __webpack_public_path__ + "img/path-5.1f4c3030.svg";